import { render, staticRenderFns } from "./LeadList.vue?vue&type=template&id=2c08ee46&scoped=true&"
import script from "./LeadList.vue?vue&type=script&lang=js&"
export * from "./LeadList.vue?vue&type=script&lang=js&"
import style0 from "./LeadList.vue?vue&type=style&index=0&id=2c08ee46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c08ee46",
  null
  
)

export default component.exports